// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"374":"teachersparents","548":"businesspartners","884":"iamstudent","931":"termsconditions","961":"careerrepresentative","965":"aboutus"}[chunkId] + "." + {"374":"64cb7f20","548":"80fa3d79","884":"4e005524","931":"a9b55952","961":"597678ea","965":"92b873e2"}[chunkId] + ".js";
};